import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { News } from '../news.model';

@JsonObject('NewsResultsResponse')
export class NewsResultsResponse extends ApiResultsResponse<News> {

  @JsonProperty('results', [News])
  override results: News[] = [];

  @JsonProperty('results_total', Number)
  resultsTotal: number = 0;
}
